import { render } from "./DashboardHeader.vue?vue&type=template&id=65678fec&ts=true"
import script from "./DashboardHeader.ts?vue&type=script&lang=ts&external"
export * from "./DashboardHeader.ts?vue&type=script&lang=ts&external"

import "./DashboardHeader.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__